import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import usePageTitle from "@/hooks/usePageTitle";

export default function NotFound() {
  usePageTitle("Page Not Found · Maqam Community Initiatives");
  return (
    <div data-testid="page-not-found" className="min-h-[80vh] flex items-center bg-white">
      <div className="max-w-3xl mx-auto px-5 md:px-8 py-24 md:py-32 text-center">
        <p className="overline">404</p>
        <h1 className="mt-3 font-serif text-5xl md:text-7xl text-[color:var(--maqam-navy)] leading-[1.05] tracking-tight">
          This page has drifted from the path.
        </h1>
        <p className="mt-6 text-[var(--maqam-muted)] text-base md:text-lg leading-relaxed max-w-xl mx-auto">
          We couldn't find what you're looking for. Return home and continue your journey with Maqam.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            data-testid="notfound-home-btn"
            className="btn-gold rounded-full px-7 py-3 font-semibold inline-flex items-center justify-center gap-2"
          >
            <ArrowLeft size={16} /> Back to Home
          </Link>
          <Link
            to="/contact"
            data-testid="notfound-contact-btn"
            className="btn-ghost rounded-full px-7 py-3 font-semibold inline-flex items-center justify-center"
          >
            Contact Our Team
          </Link>
        </div>
      </div>
    </div>
  );
}
